(function () {
  'use strict';

  var ADHESION_IDS = [8041021145141, 8041783066677, 8041783099445];

  // Prevents external cart events from triggering a doRefresh mid-operation.
  var isProcessing = false;

  // ── Section IDs ──────────────────────────────────────────────────────────────

  function getSectionIds() {
    var anchor = document.querySelector('[data-cart-summary-section]');
    var summaryId = anchor ? anchor.dataset.cartSummarySection : null;
    var itemsEl = document.querySelector('cart-items-component[data-section-id]');
    var itemsId = itemsEl ? itemsEl.dataset.sectionId : null;
    return { summaryId: summaryId, itemsId: itemsId };
  }

  // ── Fetch sections — ONE request, multiple IDs ───────────────────────────────

  async function fetchSections(ids) {
    var validIds = ids.filter(Boolean);
    if (!validIds.length) return {};
    var resp = await fetch('/?sections=' + encodeURIComponent(validIds.join(',')), { cache: 'no-store' });
    if (!resp.ok) throw new Error('sections fetch failed ' + resp.status);
    return resp.json();
  }

  // ── Apply fresh cart HTML — called once after every add/remove ───────────────
  // 1. Directly swap .cart__summary-totals (membership widget + totals)
  // 2. Dispatch cart:update so the theme morphs cart-items (count badge, line items)

  function applyCartUpdate(sections, ids) {
    if (ids.summaryId && sections[ids.summaryId]) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(sections[ids.summaryId], 'text/html');
      var newTotals = doc.querySelector('.cart__summary-totals');
      var oldTotals = document.querySelector('.cart__summary-totals');
      if (newTotals && oldTotals) oldTotals.replaceWith(newTotals);
    }

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: null,
        sourceId: 'membership-cart',
        data: { sections: sections }
      }
    }));
  }

  // ── Add adhesion ─────────────────────────────────────────────────────────────
  // Network: POST /cart/add.js → GET /?sections=...  (2 requests, sequential)

  async function addMembership(variantId, btn) {
    isProcessing = true;
    var originalHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML =
      '<span style="display:inline-flex;align-items:center;gap:6px">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
      ' style="animation:mc-spin 1s linear infinite"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>' +
      'Ajout…</span>';

    try {
      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      if (!addRes.ok) throw new Error('add failed ' + addRes.status);

      var ids = getSectionIds();
      var sections = await fetchSections([ids.summaryId, ids.itemsId]);

      applyCartUpdate(sections, ids);

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();

    } catch (err) {
      console.error('[membership-cart] add error:', err);
      alert("Erreur lors de l’ajout. Veuillez réessayer.");
      btn.innerHTML = originalHtml;
      btn.disabled = false;
    } finally {
      isProcessing = false;
    }
  }

  // ── Remove adhesion ──────────────────────────────────────────────────────────
  // Network: POST /cart/update.js → GET /?sections=...  (2 requests, sequential)
  // data-variant-id on the button avoids a preliminary /cart.js fetch entirely.

  async function removeMembership(btn) {
    isProcessing = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Retrait…'; }

    try {
      var updates = {};

      // Primary path: variant ID embedded on the button by cart-summary.liquid
      var variantId = btn && btn.dataset.variantId;
      if (variantId) {
        updates[variantId] = 0;
      } else {
        // Fallback (button rendered without data-variant-id): fetch cart to find adhesion items
        var cart = await fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        cart.items.forEach(function (item) {
          if (ADHESION_IDS.indexOf(item.product_id) !== -1) updates[item.variant_id] = 0;
        });
      }

      if (Object.keys(updates).length) {
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!res.ok) throw new Error('remove failed ' + res.status);
      }

      var ids = getSectionIds();
      var sections = await fetchSections([ids.summaryId, ids.itemsId]);
      applyCartUpdate(sections, ids);

    } catch (err) {
      console.error('[membership-cart] remove error:', err);
      alert('Erreur lors de la suppression. Veuillez réessayer.');
      if (btn) { btn.disabled = false; btn.textContent = 'Retirer'; }
    } finally {
      isProcessing = false;
    }
  }

  // ── External refresh ─────────────────────────────────────────────────────────
  // Keeps .cart__summary-totals in sync when the user adds/removes OTHER products.
  // Skipped while isProcessing so our own add/remove isn't interrupted.

  var refreshTimer = null;

  function scheduleRefresh(delay) {
    if (isProcessing) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(doRefresh, delay != null ? delay : 400);
  }

  async function doRefresh() {
    if (isProcessing) return;
    try {
      var ids = getSectionIds();
      var sections = await fetchSections([ids.summaryId]);
      if (ids.summaryId && sections[ids.summaryId]) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(sections[ids.summaryId], 'text/html');
        var newTotals = doc.querySelector('.cart__summary-totals');
        var oldTotals = document.querySelector('.cart__summary-totals');
        if (newTotals && oldTotals) oldTotals.replaceWith(newTotals);
      }
    } catch (e) {
      console.warn('[membership-cart] doRefresh error:', e);
    }
  }

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'membership-cart') return;
    scheduleRefresh(400);
  });
  ['cart:updated', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function () { scheduleRefresh(400); });
  });

  // ── Click handlers (capture phase) ──────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-membership-add-to-cart]');
    if (addBtn) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (addBtn.disabled || addBtn.dataset.processing === 'true') return;
      addBtn.dataset.processing = 'true';
      var variantId = addBtn.dataset.variantId;
      if (!variantId) { addBtn.dataset.processing = 'false'; return; }
      addMembership(variantId, addBtn).finally(function () { addBtn.dataset.processing = 'false'; });
      return;
    }

    var removeBtn = e.target.closest('[data-membership-remove]');
    if (removeBtn) {
      e.stopImmediatePropagation();
      e.preventDefault();
      if (removeBtn.disabled || removeBtn.dataset.processing === 'true') return;
      removeBtn.dataset.processing = 'true';
      removeMembership(removeBtn).finally(function () { removeBtn.dataset.processing = 'false'; });
    }
  }, true);

  // ── Spin keyframe ─────────────────────────────────────────────────────────────

  if (!document.getElementById('mc-spin-style')) {
    var s = document.createElement('style');
    s.id = 'mc-spin-style';
    s.textContent = '@keyframes mc-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(s);
  }

})();